<template>
    <div>
        <slot />
        <g-form>
            <g-form-item label="Email" :field-info="accountCreatorId ? 'This email is used by all brands that you work with. Changing this email will change it for all brands.' : ''">
                <g-input v-model="contact.email" class="input" />
            </g-form-item>
            <g-form-item label="Phone Number" class="g-mb-3">
                <phone-input ref="phone" />
            </g-form-item>
            <div class="mt-20">
                <g-button :disabled="contactStore.loading" shape="round" data-testid="update-button" theme="live" @click="updateProfile">
                    <g-typography font-weight="semibold">Update</g-typography>
                </g-button>
            </div>
        </g-form>
    </div>
</template>

<script>
    import PhoneInput from '../../../interface/form/PhoneInput.vue';
    import { useContactStore, useAccountCreatorStore } from '../../../../../stores';
    import { reactive, ref, computed } from 'vue-demi';
    import { message } from '@grininc/grin-ui';
    import useRouter from "../../../../composables/use-router";

    export default {
        /**
         * The component name
         *
         * @type {string}
         */
        name: 'ContactInfo',

        /**
         * The child components
         *
         * @type {object}
         */
        components: {
            PhoneInput
        },

        setup() {
            const contactStore = useContactStore();
            const router = useRouter().get();
            const accountCreatorId = ref(useAccountCreatorStore().data.id);
            const phone = ref(null);


            const contact = reactive({ email: contactStore.data.email });
            const hasEmailChanged = computed(() => contact.email !== contactStore.data.email);

            const updateProfile = async () => {
                contact.phone = phone.value.getPhoneNumber();
                await contactStore.updateContact(contact);
                if (!contactStore.error) {
                    //already a creator, changed email
                    if (accountCreatorId.value && hasEmailChanged.value) {
                        message.success("Check your inbox. We've sent you an email to verify your email address.");
                    }
                    //not a creator, changes email and becomes creator
                    else if (hasEmailChanged.value && contactStore.data.creator_made) {
                        message.success('Please verify your new email address.');
                        router.push({ name: 'v2.account.verify' });
                    } else {
                        message.success('Your profile has been updated.');
                    }
                } else {
                    message.error(contactStore.error);
                }
            };

            return {
                contact,
                contactStore,
                phone,
                updateProfile,
                accountCreatorId,
            };
        }
    };
</script>
